module.exports = __webpack_public_path__ + "img/PartyActivity-Mascott.159ae20a.png";